import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=e064591c&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./Settings.vue?vue&type=style&index=1&id=e064591c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e064591c",
  null
  
)

export default component.exports